import { useCallback } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { LogoutIcon } from 'foundations-assets/icons/components/LogoutIcon';
import I18n from 'I18n';
import { useBrandSettings } from '../hooks/usePortalPlatformData';
import { Image } from 'foundations-components/transitional/components/Image';
import styled from 'foundations-theming-specialty/utils';
import { LOGOUT_PATH } from '../../api/paths';
const LogoContainer = styled.div.withConfig({
  displayName: "GlobalNav__LogoContainer"
})(["height:32px;aspect-ratio:", ";"], ({
  $aspectRatio
}) => $aspectRatio);
import { DesktopNavigationMenu } from './DesktopNavigationMenu';
import { MobileNavigationMenu } from './MobileNavigationMenu';
import { useIsMobile } from '../hooks/useBreakpoint';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function GlobalNav() {
  const isMobile = useIsMobile();
  const brandSettings = useBrandSettings();
  const handleLogout = useCallback(() => {
    window.location.href = `${LOGOUT_PATH}?redirect_url=${window.location.href}`;
  }, []);
  const logo = brandSettings === null || brandSettings === void 0 ? void 0 : brandSettings.logo;
  const aspectRatio = logo !== null && logo !== void 0 && logo.width && logo !== null && logo !== void 0 && logo.height ? logo.width / logo.height : 1;
  return /*#__PURE__*/_jsxs(Flex, {
    backgroundColor: "fill-surface-default",
    paddingInline: "800",
    blockSize: "72px",
    alignItems: "center",
    justifyContent: "space-between",
    borderBlockEndWidth: "100",
    borderBlockEndStyle: "solid",
    borderColor: "border-core-subtle",
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "600",
      children: [/*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        gap: "300",
        children: logo !== null && logo !== void 0 && logo.src ? /*#__PURE__*/_jsx(LogoContainer, {
          $aspectRatio: aspectRatio,
          children: /*#__PURE__*/_jsx(Image, {
            maxBlockSize: "32px",
            src: logo.src,
            alt: logo.alt
          })
        }) : /*#__PURE__*/_jsx(Text, {
          typography: "heading-100",
          children: logo === null || logo === void 0 ? void 0 : logo.alt
        })
      }), !isMobile && /*#__PURE__*/_jsx(DesktopNavigationMenu, {})]
    }), isMobile ? /*#__PURE__*/_jsx(MobileNavigationMenu, {}) : /*#__PURE__*/_jsx(Button, {
      onClick: handleLogout,
      use: "transparent",
      size: "small",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "200",
        children: [/*#__PURE__*/_jsx(LogoutIcon, {
          color: "text-core-default",
          size: "500"
        }), /*#__PURE__*/_jsx(Text, {
          color: "text-core-default",
          children: I18n.text('customer-portal-app.signOut')
        })]
      })
    })]
  });
}